import connectors from './connectors';

export const clearUserCache = (): void => {
    if (window?.localStorage?.getItem('walletconnect')) {
        connectors.walletconnect.close();
        connectors.walletconnect.walletConnectProvider = null;
    }
    window?.localStorage?.removeItem('walletconnect');
};
